module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iTi7E"))).then(() => parcelRequire('37nVf'));